import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import CustomBreadCrumbs from "../../../common/breadcrumbs";
import { RouteConstants, AccessScopeConstants } from "../../../../constants";
import * as RoleHelper from "../../../../helpers/RoleHelper";
import {
  integrationDetailsRequest,
  resetAction,
} from "../../../../store/slices/integrationSlice";
import IntegrationForm from "../add/IntegrationForm";

const IntegrationDetails = ({
  integration,
  requesting,
  action,
  integrationDetailsRequest,
  resetAction,
  auth,
  labels,
  user,
}) => {
  const intl = useIntl();
  const { id } = useParams();
  const navigate = useNavigate();
  const [isEditable, setIsEditable] = useState(id ? false : true);

  const isEditMode = !!id;
  const isAddMode = !id;

  useEffect(() => {
    if (id) {
      integrationDetailsRequest({ id });
    }
    return () => resetAction();
  }, [id, integrationDetailsRequest, resetAction]);

  useEffect(() => {
    if ((action === "create" || action === "update") && !requesting) {
      navigate(RouteConstants.APP_ROUTE_INTEGRATIONS_LIST);
      resetAction();
    }
  }, [action, requesting, navigate, resetAction]);

  const canManageIntegrations = RoleHelper.checkRoleScope(
    user?.role?.scope,
    AccessScopeConstants.EnterpriseAccess,
    AccessScopeConstants.UpdateScope
  );

  // For add mode or edit mode (both editable and view state) - show form
  return (
    <div className="pb-8 md:pb-0">
      <CustomBreadCrumbs
        labels={labels}
        navigate={navigate}
        editLabel={isEditMode ? integration?.name : null}
      />
      <div className="edexlms-page-content">
        <div className="edexlms-page-header">
          <div className="edexlms-page-title">
            {intl.formatMessage({
              id: isAddMode ? "add_integration" : "integration_details",
            })}
          </div>
          {(isEditMode && !isEditable && (
            <div className="edexlms-page-actions">
              <Button
                icon="pi pi-pencil"
                outlined
                onClick={() => setIsEditable(!isEditable)}
                label={intl.formatMessage({ id: "edit" })}
                type="button"
                size="small"
                disabled={!canManageIntegrations || !integration?.id}
                tooltipOptions={{ showOnDisabled: true, position: "bottom" }}
                tooltip={
                  canManageIntegrations && !integration?.isSystemDefined
                    ? ""
                    : intl.formatMessage({ id: "no_permission" })
                }
              />
            </div>
          )) ||
            null}
        </div>
        <div
          className="edexlms-page-body"
          style={{
            height: "calc(100vh - 64px - 20px - 45px - 40px - 14px - 33px)",
            overflowY: "scroll",
          }}
        >
          <IntegrationForm
            integration={isEditMode ? integration : null}
            disabled={isEditMode && !isEditable}
            onCancel={() => {
              if (isAddMode) {
                navigate(RouteConstants.APP_ROUTE_INTEGRATIONS_LIST);
              } else {
                setIsEditable(false);
              }
            }}
            title={
              isAddMode
                ? intl.formatMessage({ id: "add_integration" })
                : intl.formatMessage({ id: "edit_integration" })
            }
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  integration: state.integrations.record,
  requesting: state.integrations.requesting,
  action: state.integrations.action,
  auth: state.auth,
  user: state.self?.user,
});

const mapDispatchToProps = {
  integrationDetailsRequest,
  resetAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationDetails);
